import { Loader } from '@fountain/fountain-ui-components';
import { ButtonBase, Modal } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import React, { FC, useState } from 'react';

import { useScrollBlock } from 'hooks/useScrollBlock';

import { useStyles } from './styles';

export interface ImageViewerProps {
  src: string;
  onClose: () => void;
  useModal?: boolean;
}

export const ImageViewer: FC<ImageViewerProps> = ({
  src,
  onClose,
  useModal = false,
}) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);

  useScrollBlock(!useModal);

  const content = (
    <div
      className={classes.fullscreenContainer}
      data-testid="fullscreen-container"
      onClick={onClose}
      onKeyDown={e => e.key === 'Escape' && onClose()}
      role="presentation"
    >
      <ButtonBase
        className={classes.closeButton}
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          onClose();
        }}
      >
        <CloseIcon />
      </ButtonBase>
      <div
        className={classes.imageWrapper}
        onClick={e => e.stopPropagation()}
        onKeyDown={e => e.stopPropagation()}
        role="presentation"
      >
        {loading && (
          <div className={classes.loaderContainer}>
            <Loader fullSection size="1.5rem" />
          </div>
        )}
        <img
          src={src}
          alt="Full size preview"
          className={classes.previewImage}
          style={{ display: loading ? 'none' : 'block' }}
          onLoad={() => setLoading(false)}
        />
      </div>
    </div>
  );

  if (useModal) {
    return (
      <Modal open onClose={onClose} disableAutoFocus>
        {content}
      </Modal>
    );
  }

  return content;
};
